import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, OffSubscriptionWithCatch, withActions, withSelectors } from '@res/ngg-core';
import { MachineDoc, ServicingData, ServicingModel, ServicingRef } from '../../schema/schema.interface';
import { ServicingActions } from './servicing.action';
import { ServicingState } from './servicing.state';

export type ServicingStoreModel = ServicingData & { ref: ServicingRef };

export interface ServicingStateModel {
  servicing: ServicingStoreModel[];
  selectedMachine?: MachineDoc;
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean;
  filter?: { query: AbstractQueryParams<ServicingModel>[] };
}

export const ServicingStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    servicing: ServicingState.servicing,
    servicingState: ServicingState.servicingState,
    servicingByMachines: ServicingState.servicingByMachines,
  }),
  // Actions
  withActions({
    setSelectedMachine: ServicingActions.SetSelectedMachine,
    initServicing: ServicingActions.InitServicing,
    updateServicing: ServicingActions.UpdateServicing,
    getAllServicing: ServicingActions.GetAllServicing,
    queryServicing: ServicingActions.QueryServicing,
  }),
);
